/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Packaging_Count_Log_Entry_ChangedInputs */

const vi_error_packaging_count_log_entry_changed = /** @type {(inputs: Error_Packaging_Count_Log_Entry_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mẻ kiểm kê này vừa được người khác sửa. Tải lại sổ để xem số mới rồi sửa lại nếu cần.`)
};

/**

* @param {Error_Packaging_Count_Log_Entry_ChangedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_packaging_count_log_entry_changed = /** @type {((inputs?: Error_Packaging_Count_Log_Entry_ChangedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Packaging_Count_Log_Entry_ChangedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_packaging_count_log_entry_changed(inputs)
});